import { Component } from '@angular/core';

@Component({
    selector: 'loading-dialog',
    templateUrl: 'loading-dialog.component.html',
})
export class LoadingDialogComponent {

}
